import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useState } from "react";
import { ITag } from "dto/ITag";
import EditIcon from "assets/icons/edite.svg?react";
import Input from "components/Input";
import Button from "components/Button";
import ReactDOM from "react-dom";
import Chip from "components/Chip";
import { Tooltip } from "@mui/material";
import InputInline from "components/InputInline";
import { useTranslation } from "react-i18next";

const EditTagModal = ({
  tag,
  onChange,
}: {
  tag: ITag;
  onChange: (tag: ITag) => void;
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(tag.Name ?? "");

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.window}>
        <div className={styles.wrapper}>
          <div className={styles.title}>{t("tooltips.editTag")}</div>
          <Input
            disabledTags
            label={t("forms.label")}
            value={value}
            onChange={(t) => setValue(t)}
          />
          <div className={styles.button}>
            <Button
              text={t("common.save")}
              onClick={() => onChange({ ...tag, Name: value })}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

const TagBadge: FC<Props> = ({
  tag,
  onEdit,
  onRemove,
  useBigChip,
}) => {
  const { t } = useTranslation();
  const [editTag, setEditTag] = useState(false);

  const [value, setValue] = useState(tag.Name ?? "");

  const handleOnEdit = (newName: string) => {
    const newTag = tag;
    newTag.Name = newName;

    onEdit(newTag);
    setEditTag(false);
    setValue(newName);
  };

  if (editTag) {
    return (
      <InputInline
        value={value}
        onChange={handleOnEdit}
        onCancel={() => setEditTag(false)}
      ></InputInline>
    );
  }

  return (
    <>
      <Chip
        small={!useBigChip}
        element={
          <>
            {!onEdit && tag?.Name}
            {onEdit && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {tag?.Name}
                <Tooltip title={t("common.edit")}>
                  <div>
                    <EditIcon
                      onClick={() => setEditTag(true)}
                      className={styles.editIcon}
                    />
                  </div>
                </Tooltip>
              </div>
            )}
          </>
        }
        onDelete={
          onRemove
            ? () => {
                onRemove(tag);
              }
            : undefined
        }
      />

      {/* <div
        onMouseEnter={() => setShowRemove(true)}
        onMouseLeave={() => setShowRemove(false)}
        className={`${className ? className : styles.tag}`}
      >
        {!!tag?.Name?.length && <>#{tag?.Name?.toUpperCase()}</>}
        {onEdit && (showRemove || showMenu) && (
          <FontAwesomeIcon
            onClick={() => setShowMenu(!showMenu)}
            className={styles.remove}
            icon={faEllipsisVertical}
          />
        )}
        {onRemove && !onEdit && (showRemove || allwaysShowRemove) && (
          <CloseIcon
            onClick={(e) => {
              onRemove?.(tag);
              e.stopPropagation();
            }}
            className={`${removeClassName ? removeClassName : styles.remove}`}
          />
        )}
        {showMenu && (
          <div className={styles.dropdown}>
            <div
              onClick={() => {
                setEditTag(true);
                setShowMenu(false);
              }}
              className={styles.box}
            >
              Edytuj
            </div>
            {onRemove && (
              <div
                onClick={() => {
                  onRemove(tag);
                  setShowMenu(false);
                }}
                className={styles.box}
              >
                Usuń
              </div>
            )}
          </div>
        )}
      </div> */}
      {editTag && onEdit && (
        <EditTagModal
          tag={tag}
          onChange={(tag) => {
            onEdit(tag);
            setEditTag(false);
          }}
        />
      )}
    </>
  );
};

export default TagBadge;
